import customAxios from './axios';
import CONFIG from '../../config';
import * as types from './types';

export const jobReferenceData = (data) => ({
    type: types.JOB_REFERENCE_DATA,
    data
});

export const addJobReference = (data) => ({
    type: types.ADD_JOB_REFERENCE,
    data
});

export const removeJobReference = (id) => ({
    type: types.REMOVE_JOB_REFERENCE,
    id
});

export const getJobNotifications = (status, passportNo, jobId) => {
    return customAxios.get(CONFIG.apiURL + `/TypingCenterStaffs/GetJobNotifications?status=${status}&passportNo=${passportNo}&jobId=${jobId}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getJobCountsForActionRequested = () => {
    return customAxios.get(CONFIG.apiURL + '/TypingCenterAdminDashboard/GetJobCountsForActionRequested').then(res => {
        let response = res['data'];
        return response;
    });
}

export const getAllJobs = (payload) => {
    return customAxios.post(CONFIG.apiURL + `/TypingCenterStaffs/GetAssignedJobsWithFilter`, payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getIndividual = (id) => {
    return customAxios.get(CONFIG.apiURL + `/Jobs/JobDetails?JobId=${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const statusesForTypingCenter = (payload) => {
    return customAxios.get(CONFIG.apiURL + '/Jobs/StatusesForTypingCenter', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllJobStatuses = (payload) => {
    return customAxios.get(CONFIG.apiURL + '/Jobs/GetAllJobStatuses', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const createReference = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Jobs/CreateReference', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const updateReference = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Jobs/UpdateReference', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const updateJobStatus = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Jobs/UpdateJobStatus', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const sendJobMail = (payload, jobId) => {
    return customAxios.post(CONFIG.apiURL + `/JobMail/SendJobDocuments?jobId=${jobId}`, payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const UpdateAgentSelectionStatus = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Jobs/UpdateAgentSelectionStatus', payload).then(res => {
        let response = res;
        return response;
    });
};

export const jobAttributes = (jobID) => {
    return customAxios.get(CONFIG.apiURL + `/ProcessCosts/DetailsByJob?jobId=${jobID}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const createJobNote = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/JobNote/CreateNote', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const initiateDeliveryRequest = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/DeliveryRequestJob/Create', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const uploadPaymentReceipt = (payload) => {
    return customAxios.post(CONFIG.documentURL + '/DocumentVault/ReceiptDocument/Upload', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const downloadPaymentReceipt = (documentId) => {
    return customAxios.post(CONFIG.documentURL + `/DocumentVault/ReceiptDocument/Download?documentId=${documentId}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getMetaDataPaymentReceipt = (documentIds) => {
    return customAxios.get(CONFIG.documentURL + `/DocumentVault/ReceiptDocument/GetMetadata?documentIds=${documentIds}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getDocumentMetaData = (userID, documentIds) => {
    return customAxios.get(CONFIG.documentURL + `/DocumentVault/Document/GetMetadata?userId=${userID}&documentIds=${documentIds}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const downloadDocument = (userID, documentID) => {
    return customAxios.get(CONFIG.documentURL + `/DocumentVault/Document/Download?userId=${userID}&documentId=${documentID}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const downloadZipDocument = (payload) => {
    return customAxios.post(CONFIG.documentURL + `/DocumentVault/Document/MultiDownload`, payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllDeliveryTypeAndStatus = () => {
    return customAxios.get(CONFIG.apiURL + `/DeliveryRequestJob/GetAllDeliveryTypeAndStatus`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllDepartments = () => {
    return customAxios.get(CONFIG.apiURL + '/Departments').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllMasterProcesses = () => {
    return customAxios.get(CONFIG.apiURL + '/MasterProcesses').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllProcesses = () => {
    return customAxios.get(CONFIG.apiURL + '/Processes').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getAllServices = () => {
    return customAxios.get(CONFIG.apiURL + '/Departments/Services').then(res => {
        let response = res['data'];
        return response;
    });
};

export const getBackOfficeDocumentIds = (id) => {
    return customAxios.get(CONFIG.apiURL + `/Documents/GetBackOfficeDocumentIds?Id=${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const downLoadCsv = (payload) => {
    return customAxios.post(CONFIG.apiURL + `/Jobs/GetTypingCenterJobsCsv`, payload, { responseType: 'arraybuffer' }).then(res => {
        return res;
    });
};

export const getJobStatusLogs = (jobId) => {
    return customAxios.get(CONFIG.apiURL + `/Jobs/GetJobLogsByUserType?jobId=${jobId}`).then(res => {
        return res['data'];
    });
};

export const addBackOfficeDocumentIds = (payload) => {
    return customAxios.post(CONFIG.apiURL + `/Documents/AddBackOfficeDocumentIds`, payload).then(res => {
        return res;
    });
};
